import { Injectable, inject, DestroyRef } from '@angular/core';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { LocumsMarginCalculatorEvents } from '../enums/locums-margin-calculator-events.enum';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MarginContractStore } from './margin-contract.store';

@Injectable({ providedIn: 'root' })
export class MarginContractReducer {
    private readonly eventBus = inject(EventBusService);
    private readonly marginContractStore = inject(MarginContractStore);
    private readonly destroy$ = inject(DestroyRef);

    constructor() {
        this.listenToLoadMarginDetailsEvent();
    }

    private listenToLoadMarginDetailsEvent() {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.LOCUMS_1099_MARGIN_CALCULATOR_LOAD_MARGIN_DETAILS)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginContractStore.updateMarginContractFromData(
                    event.payload.marginDetails.marginContractDetails
                );
            });
    }
}
